<template>
    <div class="popup-overlay" @click.self="closePopup">
        <div class="popup-content bg-white flex flex-col items-center minHeightCard h-full widthCard rounded-lg">
            <button class="close-btn" @click="closePopup">
                <img src="../../assets/img/close-button.png" alt="Close">
            </button>
            <Star :score="score" />
            <p class="review-text text-sm px-3 text-center">"{{ reviewText }}"</p>
            <p class="review-name name mb-3 font-bold text-sm text-center">{{ reviewerName }}</p>
        </div>
    </div>
</template>

<script>
import Star from '@/js/components/Star.vue';

export default {
    components: {
        Star,
    },
    props: {
        score: {
            type: Number,
            required: true,
            validator: function (value) {
                return value >= 0 && value <= 5;
            },
        },
        reviewerName: {
            type: String,
            required: true,
        },
        reviewText: {
            type: String,
            required: true,
        },
    },
    methods: {
        closePopup() {
            this.$emit('close');
        },
    },
};
</script>
<style scoped>
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
}

.popup-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    width: 400px;
    height: 300px;
    max-width: 90%;
    max-height: 90%;
    overflow-y: auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;
}

.review-name {
    margin-bottom: 20px;
    margin-top: 20px;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 5px 8px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    display: flex; 
    align-items: center; 
    justify-content: center; 
}

.close-btn img {
    width: 30px; 
    height: 30px;
}

</style>
